import _ from 'lodash';
import React, {FunctionComponent} from 'react';
import {Grid, makeStyles} from '@material-ui/core';
import {Business} from '@material-ui/icons';
import {OwnerType} from '@treez/commons/sharedTypings/product';
import {StoreIcon, BrandTreezIcon} from '@treez-ui/core/icons';

const {BRAND, ORG, STORE} = OwnerType;

interface Props {
    ownerType: OwnerType;
    productForm: boolean;
}

export const OwnerTypeCell: FunctionComponent<Props> = (props: Props) => {
    const {ownerType, productForm} = props;

    const useStyles = makeStyles({
        iconContainer: {
            width: '20px',
            marginRight: '8px',
        },
        ownerTypeCell: {
            borderLeft: productForm ? '' : '1px solid grey',
            display: 'flex',
            height: '80px',
        },
    });

    const renderOwnerTypeIcon = () => {
        switch (ownerType) {
            case BRAND:
                return <BrandTreezIcon />;
            case ORG:
                return <Business />;
            case STORE:
                return <StoreIcon />;
        }
    };

    const {iconContainer, ownerTypeCell} = useStyles();

    return (
        <Grid
            item
            container
            alignContent="center"
            alignItems="center"
            justifyContent="center"
            className={ownerTypeCell}
        >
            <Grid className={iconContainer}>{renderOwnerTypeIcon()}</Grid>
            {_.startCase(ownerType)}
        </Grid>
    );
};

export default OwnerTypeCell;
